<!--  -->
<template>
  <div class="main_box">
    <div class="nav_menu">
      <div class="menu_left">
        <span style="color: #606266">站点名称：</span>
        <el-input
          placeholder="请输入站点名称"
          v-model="searchValue.siteName"
        ></el-input>
        <el-date-picker
          :editable="false"
          style="margin-left: -10px"
          v-model="searchValue.searhTime"
          type="datetimerange"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          format="yyyy-MM-dd"
          prefix-icon="el-icon-time"
          value-format="yyyy-MM-dd"
          clear-icon=""
          :picker-options="pickerOptions"
        >
        </el-date-picker>
        <el-button type="primary" @click="handleSearch">查询</el-button>
        <el-button type="info" @click="handleReset">重置</el-button>
      </div>
      <div class="menu_right">
        <el-button type="success" @click="handleExport">导出</el-button>
      </div>
    </div>
    <div>
      <el-table
        :header-cell-style="{
          'background-color': '#4073b6',
          color: '#FFFFFF'
        }"
        :data="tableData"
        stripe
        style="width: 100%"
        v-loading="loading"
        element-loading-text="数据量过大，加载中..."
      >
        <el-table-column type="index" prop="sid" label="序号" width="95">
        </el-table-column>
        <el-table-column prop="siteName" label="站点名称"> </el-table-column>
        <el-table-column prop="num" label="闸孔"> </el-table-column>
        <el-table-column prop="openTime" label="开启时间"> </el-table-column>
        <el-table-column prop="closeTime" label="关闭时间"> </el-table-column>
        <el-table-column prop="runTime" label="本次运行时长"> </el-table-column>
         <el-table-column prop="traffic" label="累计流量"> </el-table-column>
        <el-table-column prop="closeEmp" width="150" label="负责人">
        </el-table-column>
      </el-table>
      <el-pagination
        background
        :hide-on-single-page="true"
        layout="total, prev, pager, next, jumper"
        :total="pagination.total"
        @current-change="handleCurrent"
        :current-page="pagination.pageNum"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        }
      },
      tableData: [],
      value1: "",
      pagination: {
        size: 10,
        pageNum: 1,
        total: 0
      },
      searchValue: {
        siteName: "",
        searhTime: [],
        startTime: "",
        endTime: ""
      },
      loading: true
    };
  },
  computed: {},
  watch: {},
  methods: {
    handleExport() {
      let { endTime, startTime, siteName, searhTime } = this.searchValue;
      if (searhTime.length) {
        startTime = searhTime[0];
        endTime = searhTime[1];
        fetch(
          this.$axios.defaults.baseURL +
            `/gateUpRecordItem/export?endTime=${endTime}&startTime=${startTime}&siteName=${siteName}`,
          {
            headers: {
              token: localStorage.getItem("token")
            }
          }
        )
          .then(res => {
            return res.blob();
          })
          .catch(err => {
            console.log(err);
          })
          .then(e => {
            const a = document.createElement("a");
            a.href = URL.createObjectURL(e);
            a.download = "闸门起闭统计表.xlsx";
            a.click();
          });
      } else {
        fetch(
          this.$axios.defaults.baseURL +
            `/gateUpRecordItem/export?endTime=${endTime}&startTime=${startTime}&siteName=${siteName}`,
          {
            headers: {
              token: localStorage.getItem("token")
            }
          }
        )
          .then(res => {
            return res.blob();
          })
          .catch(err => {
            console.log(err);
          })
          .then(e => {
            const a = document.createElement("a");
            a.href = URL.createObjectURL(e);
            a.download = "闸门起闭统计表.xlsx";
            a.click();
          });
      }
    },
    getList() {
      this.loading = true;
      let { pageNum, size } = this.pagination;
      this.$get(`/gateUpRecordItem/page/${pageNum}/${size}`).then(res => {
        this.tableData = res.data.list;
        this.pagination.total = res.data.total;
        this.loading = false;
      });
    },
    handleCurrent(page) {
      this.pagination.pageNum = page;
      this.handleSearch();
    },
    handleSearch() {
      let { pageNum, size } = this.pagination;
      let { endTime, startTime, siteName } = this.searchValue;
      this.loading = true;
      if (this.searchValue.searhTime.length) {
        startTime = this.searchValue.searhTime[0];
        endTime = this.searchValue.searhTime[1];
        this.$get(`/gateUpRecordItem/page/${pageNum}/${size}`, {
          siteName,
          endTime,
          startTime
        })
          .then(res => {
            this.tableData = res.data.list;
          })
          .catch(err => {
            console.log(err);
          })
          .finally(() => {
            this.loading = false;
          });
      } else {
        this.$get(`/gateUpRecordItem/page/${pageNum}/${size}`, {
          siteName
        })
          .then(res => {
            this.tableData = res.data.list;
          })
          .catch(err => {
            console.log(err);
          })
          .finally(() => {
            this.loading = false;
          });
      }
    },
    handleReset() {
      this.pagination.pageNum = 1;
      this.searchValue.siteName = "";
      this.searchValue.searhTime = "";
      this.getList();
    }
  },
  created() {
    this.getList();
  },
  mounted() {}
};
</script>
<style lang="scss" scoped>
::v-deep .el-range-input {
  background: #f3f4f8 !important;
}
::v-deep .el-range-separator {
  background: #f3f4f8 !important;
}
::v-deep .el-date-editor.el-range-editor.el-input__inner {
  width: calc(265 / 1920 * 100vw) !important ;
}
</style>
